import React, { useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import "./generatePDF.css";
import { useSelector } from "react-redux";
import JsBarcode from "jsbarcode";
import QRCode from "react-qr-code";
import { renderToStaticMarkup } from "react-dom/server";
import { Canvg } from "canvg";
import { uiAlert } from "../../../../components/alerts/customAlert/uiAlert";

/* const getImageAsBase64 = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result); // base64 string
    reader.onerror = reject;
    reader.readAsDataURL(blob); // Convert to base64
  });
}; */
/**  Create QR-PNG for jsPDF  */
async function qrToPngDataURL(value, sizePx = 120) {
  // 1️⃣ render the React component to an SVG string
  const svgMarkup = renderToStaticMarkup(
    <QRCode
      value={value}
      size={sizePx} // px width/height of SVG viewBox
      level='M'
      bgColor='#FFFFFF'
      fgColor='#000000'
    />,
  );

  // 2️⃣ draw that SVG onto an off-screen canvas via canvg
  const canvas = document.createElement("canvas");
  canvas.width = sizePx;
  canvas.height = sizePx;
  const ctx = canvas.getContext("2d");
  // canvg v4 (promise-based)
  const v = await Canvg.fromString(ctx, svgMarkup);
  await v.render(); // wait until painted

  // 3️⃣ return PNG dataURL
  return canvas.toDataURL("image/png");
}
const drawRoundedImage = async (imgUrl, radius = 10) => {
  const img = new Image();
  img.crossOrigin = "Anonymous"; // If loading from a different origin
  img.src = imgUrl;

  await new Promise((resolve) => (img.onload = resolve));

  const size = 250; // Adjust size as needed
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;

  const ctx = canvas.getContext("2d");

  // Draw rounded rectangle path
  ctx.beginPath();
  ctx.moveTo(radius, 0);
  ctx.lineTo(size - radius, 0);
  ctx.quadraticCurveTo(size, 0, size, radius);
  ctx.lineTo(size, size - radius);
  ctx.quadraticCurveTo(size, size, size - radius, size);
  ctx.lineTo(radius, size);
  ctx.quadraticCurveTo(0, size, 0, size - radius);
  ctx.lineTo(0, radius);
  ctx.quadraticCurveTo(0, 0, radius, 0);
  ctx.closePath();
  ctx.clip();

  // Draw the image inside the clipped region
  ctx.drawImage(img, 0, 0, size, size);

  // Return base64 image
  return canvas.toDataURL("image/png");
};

const InvoicePDF = ({ invoiceData, setPdfBlob, sendAsEmail = false }) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [storeLogo, setStoreLogo] = useState(null); // State to hold the store logo
  const { store } = useSelector((state) => state.store);
  const { user } = useSelector((state) => state.webStoreUser);

  const currency = user.userCountryCurrencyCode;

  // 3️⃣ Generate Barcode Using JsBarcode
  /*   const canvas = document.createElement("canvas");
  JsBarcode(canvas, invoiceData.transID, {
    format: "CODE128",
    width: 2,
    height: 50,
    displayValue: true,
  }); */

  // 4️⃣ Add Barcode Image to PDF
  //  // Adjust size as needed

  //const barcodeImage = canvas.toDataURL("image/png");

  useEffect(() => {
    // Auto-generate PDF on mount

    console.log(invoiceData, "invoiceData");

    generatePDF();

    // Cleanup function to close current  window
  }, []);

  const generatePDF = async () => {
    // Reset any previous error
    setErrorMessage("");
    // Set loading state
    setIsGenerating(true);

    try {
      // Create new jsPDF instance
      const doc = new jsPDF();

      // get base64 image of store logo
      // const base64Logo = await getImageAsBase64(store.storeImage); // Default logo if not provided
      const base64Logo = await drawRoundedImage(store.storeImage); // Default logo if not provided
      const barcodeImage = await qrToPngDataURL(invoiceData.transID, 120);

      // Function to create header section (business info, invoice details, etc.)
      const createHeaderSection = (pageNum) => {
        try {
          // Add business logo (using a gray rectangle with icon)
          doc.setDrawColor(180, 180, 180);
          doc.setFillColor(255, 255, 255);
          doc.roundedRect(20, 20, 30, 30, 2, 2, "FD");
          doc.addImage(base64Logo, "PNG", 21, 21, 28, 28); // Add logo image

          // Draw a store/shop icon
          /* doc.setDrawColor(255, 255, 255);
          doc.setLineWidth(0.5);
          doc.line(28, 30, 42, 30);
          doc.line(28, 35, 42, 35);
          doc.line(30, 25, 30, 40);
          doc.line(40, 25, 40, 40); */

          // Add business details from invoiceData
          doc.setFontSize(11);
          doc.text(store.storeName || "Business Name", 55, 25);
          doc.setFontSize(9);

          // Format address appropriately
          const businessAddress = store.storeAddress || "Street Address, City, Country, Zip Code";
          const addressParts = businessAddress.split(",");

          if (addressParts.length > 1) {
            // Display first part of address
            doc.text(addressParts.slice(0, addressParts.length - 1).join(","), 55, 32);
            // Display zip code and remaining part
            doc.text(addressParts[addressParts.length - 1].trim(), 55, 39);
          } else {
            doc.text(businessAddress, 55, 32);
            doc.text("", 55, 39);
          }

          // Add invoice details
          doc.setFontSize(9);
          doc.text(`Receipt# ${invoiceData.transID || "00000"}`, 190, 25, { align: "right" });
          doc.setFontSize(8);
          doc.text("Issue date", 190, 32, { align: "right" });
          doc.text(new Date(invoiceData.transactionDetails.date).toLocaleDateString() || "04/07/2023", 190, 39, { align: "right" });

          // Add horizontal line
          doc.setDrawColor(80, 90, 100);
          doc.setLineWidth(1);
          doc.line(20, 55, 190, 55);

          // Only add business name and QR code on first page
          if (pageNum === 1) {
            // Add business name and custom message
            doc.setFontSize(22);
            doc.text(store.storeName || "Business name", 20, 75);
            doc.setFontSize(10);
            doc.text(invoiceData.customMessage || "Thank you for your purchase.", 20, 85);

            // Improve QR code placement and design - positioned in same row as business name
            // QR code square frame with better proportions
            doc.setDrawColor(220, 220, 220);
            doc.setFillColor(255, 255, 255);
            // Wider barcode that looks better
            // doc.rect(140, 65, 50, 30, "S");

            // Generate barcode with better spacing and more lines for a "cooler" look
            const qrValue = invoiceData?.invoiceNumber || "00000";
            const qrX = 143; // Adjusted starting position
            const qrY = 69;
            const qrHeight = 20;

            // Generate barcode visual pattern with more lines and tighter spacing
            const qrLines = 25; // More lines
            const qrMaxWidth = 1.2;
            const qrMinWidth = 0.3;
            doc.setDrawColor(0, 0, 0);

            // Calculated optimal spacing based on width
            const spacing = 1.8;

            /*   for (let i = 0; i < qrLines; i++) {
              const lineWidth = Math.random() * (qrMaxWidth - qrMinWidth) + qrMinWidth;
              doc.setLineWidth(lineWidth);
              doc.line(qrX + i * spacing, qrY, qrX + i * spacing, qrY + qrHeight);
            } */
            doc.addImage(barcodeImage, "PNG", 164, 68, 22, 22);
            // Add text below barcode with better alignment
            doc.setFontSize(9);
            doc.setTextColor(255, 102, 0); // Orange color for the number
            // doc.text(qrValue, qrX + 25, qrY + qrHeight + 5, { align: "center" });

            doc.setTextColor(0, 0, 0); // Reset text color

            // Add sections with column layout - using exact positioning to match image
            const leftMargin = 20; // Left margin
            const rightMargin = 20; // Right margin
            const pageWidth = 210; // Total page width (A4)
            const usableWidth = pageWidth - leftMargin - rightMargin; // Usable width
            const gapWidth = 15; // Gap between columns

            // Calculate for 3 equal columns with gaps in between
            const colWidth = (usableWidth - 2 * gapWidth) / 3;

            const leftColX = leftMargin; // Left column (BILL TO)
            const midColX = leftColX + colWidth + gapWidth; // Middle column (DETAILS)
            const rightColX = midColX + colWidth + gapWidth; // Right column (PAYMENT)

            // Make sure the rightmost column doesn't exceed usable width
            const maxRightEdge = pageWidth - rightMargin;

            // Add horizontal lines above section headers with equal width and spacing
            doc.setDrawColor(220, 220, 220);
            doc.setLineWidth(0.5);

            // First section line (left) - BILL TO
            doc.line(leftColX, 100, leftColX + colWidth - 5, 100);

            // Second section line (middle) - DETAILS
            doc.line(midColX, 100, midColX + colWidth - 5, 100);

            // Third section line (right) - PAYMENT
            doc.line(rightColX, 100, Math.min(rightColX + colWidth - 5, maxRightEdge - 5), 100);

            doc.setFontSize(11);
            doc.setFont("times", "bold");
            doc.text("CUSTOMER", leftColX, 110);
            doc.text("DETAILS", midColX, 110);
            doc.text("PAYMENT", rightColX, 110);

            // BILL TO section content - use customer data from invoiceData
            doc.setFont("times", "normal");
            doc.setFontSize(10);
            //text color gray
            doc.setTextColor(50, 50, 50);
            doc.text(invoiceData.customer?.fullName || "Customer Name", leftColX, 120);
            doc.text(invoiceData.customer?.email || "customer@example.com", leftColX, 127);
            doc.text(invoiceData.customer?.phoneNumber || "Phone number", leftColX, 134);
            doc.text(invoiceData.customer?.address?.split(",")[0] || "Street address", leftColX, 141);
            doc.text(invoiceData.customer?.address?.split(",").slice(1).join(",") || "", leftColX, 148);

            // DETAILS section content with text wrapping for long content
            doc.setTextColor(0, 0, 0);
            doc.setFont("times", "normal");
            doc.setFontSize(10);

            // Get details text from invoiceData or use default
            const detailsText = invoiceData.details || "Enter a brief description about your job or project.";

            // Split long text into multiple lines with maximum width
            const maxWidth = colWidth - 10; // Account for padding
            const lineHeight = 7; // Line spacing

            // Function to split text into lines based on max width
            /*   const splitTextIntoLines = (text, maxWidth) => {
              // Use jsPDF's built-in text splitting
              return doc.splitTextToSize(text, maxWidth);
            }; */

            // Get the lines array
            /*  const detailsLines = splitTextIntoLines(detailsText, maxWidth); */

            // Render each line with proper spacing
            /*  detailsLines.forEach((line, index) => {
                doc.text(line, midColX, 120 + index * lineHeight); 
            }); */
            invoiceData.transactionDetails.deliveryStatus === "supplied"
              ? doc.setTextColor(0, 120, 200)
              : invoiceData.transactionDetails.deliveryStatus === "returned"
                ? doc.setTextColor(145, 141, 141)
                : doc.setTextColor(208, 25, 15);
            doc.text(
              `Delivery status:  ${
                invoiceData.transactionDetails.deliveryStatus.charAt(0).toUpperCase() + invoiceData.transactionDetails.deliveryStatus.slice(1)
              }`,
              midColX,
              120,
            );

            doc.setTextColor(10, 10, 10);
            doc.text(`Number of items :  ${invoiceData.transactionDetails.numberOfItems}`, midColX, 127);

            // PAYMENT section content - use due date and total from invoiceData
            doc.text(
              `Payment mode:  ${
                invoiceData.transactionDetails.paymentMode.charAt(0).toUpperCase() + invoiceData.transactionDetails.paymentMode.slice(1) || "cash"
              }`,
              rightColX,
              120,
            );

            // Format total due with 2 decimal places
            const totalAmount = invoiceData.transactionDetails?.totalAmount || 0;
            /* const formattedTotalDue = typeof totalAmount === "number" ? `${totalAmount.toFixed(2)}` : typeof totalAmount === "string" ? totalAmount : "0.00"; */
            doc.setFont("times", "bold");
            doc.setTextColor(0, 0, 0);
            doc.text(`Total: ${currency} ${totalAmount.toLocaleString()}`, rightColX, 127);

            return 160; // Return Y position where table should start on first page
          } else {
            // For subsequent pages, add page number at top of page
            doc.setFontSize(9);
            doc.setFont("times", "normal");
            doc.text(`Page ${pageNum}`, 190, 65, { align: "right" });

            return 70; // Return Y position where table should start on subsequent pages
          }
        } catch (error) {
          console.error("Error creating header section:", error);
          throw error;
        }
      };

      // Function to add table headers
      const addTableHeaders = (startY) => {
        const tableX = 20;
        const tableWidth = 170;
        const colWidths = [tableWidth * 0.45, tableWidth * 0.15, tableWidth * 0.2, tableWidth * 0.2];
        const headerHeight = 10;
        const headers = ["ITEM", "QTY", `PRICE (${currency})`, `Total (${currency})`];

        // Calculate column positions
        const col1X = tableX;
        const col2X = col1X + colWidths[0];
        const col3X = col2X + colWidths[1];
        const col4X = col3X + colWidths[2];
        const tableEndX = col4X + colWidths[3];

        // Set border color to light gray
        doc.setDrawColor(220, 220, 220);
        doc.setLineWidth(0.5);

        // Draw header row
        const headerY = startY;

        // Draw header horizontal lines (keep these)
        doc.line(tableX, headerY, tableEndX, headerY);
        doc.line(tableX, headerY + headerHeight, tableEndX, headerY + headerHeight);

        // Add header text - centered vertically in the header row
        doc.setFont("times", "bold");
        doc.setFontSize(10);
        // Calculate vertical center of header row
        const headerTextY = headerY + headerHeight / 2 + 3; // Add a small offset for text alignment

        doc.text(headers[0], col1X + 5, headerTextY);

        // Right-aligned headers
        doc.text(headers[1], col3X - 5, headerTextY, { align: "right" });
        doc.text(headers[2], col4X - 5, headerTextY, { align: "right" });
        doc.text(headers[3], tableEndX - 5, headerTextY, { align: "right" });

        return {
          tableX,
          tableEndX,
          col1X,
          col3X,
          col4X,
          nextY: startY + headerHeight,
          colWidths,
        };
      };

      // Separate function for page footer to ensure consistency
      const addPageFooter = (pageNum, totalPages) => {
        const footerY = 260; // Fixed position at bottom of page - always consistent

        doc.setFont("times", "normal");
        doc.setFontSize(9);
        doc.text("Inventory manager", 20, footerY);
        doc.text("Service provided by Pragma Solutions Ltd", 20, footerY + 6);

        // Add styled link text
        doc.setTextColor(0, 120, 200);
        doc.text("www.storelense.com", 20, footerY + 12);

        // Add page number
        doc.setTextColor(0, 0, 0);
        doc.text(`Page ${pageNum} of ${totalPages}`, 190, footerY + 12, { align: "right" });

        return footerY;
      };

      // Generate dynamic sample items if needed for testing
      let itemsToRender = invoiceData.products;

      // Comment out test data generation to use actual invoice items
      /*
      itemsToRender = Array(3)
        .fill()
        .map((_, index) => ({
          name: `Item ${index + 1}`,
          description: `Describe your item ${index + 1}`,
          quantity: 1,
          price: 100.0,
          amount: 100.0,
        }));
      */

      // Define constants for pagination
      const rowHeight = 18;
      const totalItems = itemsToRender.length;
      const FOOTER_Y = 260; // Fixed footer position for consistency

      // Calculate total pages before starting - fix for pagination display
      // Estimate items per page (5 is a reasonable estimate for first page, more for subsequent pages)
      const firstPageCapacity = 2;
      const otherPagesCapacity = 8;
      let totalPages = 1;
      if (totalItems > firstPageCapacity) {
        totalPages = Math.ceil((totalItems - firstPageCapacity) / otherPagesCapacity) + 1;
      }

      // IMPROVED APPROACH FOR BETTER RENDERING WITH ANY NUMBER OF ITEMS

      // Create first page (always exists)
      let currentPage = 1;
      let currentY = createHeaderSection(1);
      let tableInfo = addTableHeaders(currentY);
      currentY = tableInfo.nextY;

      // Render each item one by one with improved algorithm
      let itemsOnCurrentPage = 0;
      let itemsProcessed = 0;

      while (itemsProcessed < totalItems) {
        const item = itemsToRender[itemsProcessed];
        const isLastItem = itemsProcessed === totalItems - 1;

        // Space needed for this item
        const itemSpace = rowHeight;

        // Space needed for totals if this is the last item
        const totalsSpace = isLastItem ? 30 : 0;

        // Calculate if this item + totals (if last) will fit on current page
        const spaceAvailable = FOOTER_Y - currentY - 20; // 20px buffer
        const spaceNeeded = itemSpace + (isLastItem ? totalsSpace : 0);

        if (spaceNeeded > spaceAvailable && itemsOnCurrentPage > 0) {
          // Only create a new page if we've already added at least one item to current page
          // Add footer to current page

          addPageFooter(currentPage, totalPages); // Use pre-calculated total pages

          // Start a new page
          doc.addPage();
          currentPage++;

          // Reset counters for the new page
          currentY = createHeaderSection(currentPage);
          tableInfo = addTableHeaders(currentY);
          currentY = tableInfo.nextY;
          itemsOnCurrentPage = 0;
        } else {
          // Now we are sure the item fits or we're forcing it onto the page, render it

          // Draw horizontal line at the bottom of the row
          doc.line(tableInfo.tableX, currentY + rowHeight, tableInfo.tableEndX, currentY + rowHeight);

          // Add item text
          doc.setFont("times", "normal");
          doc.setTextColor(0, 0, 0);
          console.log("item", item);

          doc.text(item.name, tableInfo.col1X + 5, currentY + 10);

          // Add description in gray
          doc.setTextColor(150, 150, 150);
          doc.text((item.serialNumber && `SN:- ${item.serialNumber}`) || item.category || "", tableInfo.col1X + 5, currentY + 16);

          // Reset text color
          doc.setTextColor(0, 0, 0);

          // Add right-aligned values
          const qty = typeof item.quantity === "number" ? item.quantity.toString() : item.quantity;
          const price = typeof item.soldUnitPrice === "number" ? `${item.soldUnitPrice.toFixed(2)}` : item.soldUnitPrice;
          const amount = typeof item.totalAmount === "number" ? `${item.totalAmount.toFixed(2)}` : item.totalAmount;

          doc.text(`${qty} ${item.unit}`, tableInfo.col3X - 5, currentY + 10, { align: "right" });
          doc.text(` ${price}`, tableInfo.col4X - 5, currentY + 10, { align: "right" });
          doc.text(` ${amount}`, tableInfo.tableEndX - 5, currentY + 10, { align: "right" });

          // Move to next row
          currentY += rowHeight;
          itemsOnCurrentPage++;
          itemsProcessed++;

          // If this was the last item, add totals section
          if (isLastItem) {
            // Check if totals will fit
            if (currentY + totalsSpace > FOOTER_Y) {
              // Not enough space for totals, create new page
              addPageFooter(currentPage, totalPages); // Use pre-calculated total pages
              doc.addPage();
              currentPage++;
              currentY = createHeaderSection(currentPage);
              tableInfo = addTableHeaders(currentY);
              currentY = tableInfo.nextY;
            }

            const tableX = 20;
            const tableWidth = 170;
            const colWidths = [tableWidth * 0.45, tableWidth * 0.15, tableWidth * 0.2, tableWidth * 0.2];
            const col1X = tableX;
            const col2X = col1X + colWidths[0];
            const col3X = col2X + colWidths[1];
            const col4X = col3X + colWidths[2];
            const tableEndX = col4X + colWidths[3];

            const subtotalY = currentY + 10;
            let taxY = subtotalY + 5;
            let lineY = taxY + 10;
            let totalDueY = lineY + 10;

            // Format monetary values with proper decimal places
            const subtotal = invoiceData.transactionDetails?.subTotal || 0;
            const initialPayment = invoiceData.operationType?.intialPayment || 0;
            const vatAmount = invoiceData.transactionDetails?.vat || 0;
            const discount = invoiceData.transactionDetails?.discount || 0;
            const clearedOldBalance = invoiceData.transactionDetails?.clearedbalance || 0;
            const totalDue = Number(invoiceData.transactionDetails?.totalAmount) || 0;

            const formattedVat = typeof vatAmount === "number" ? `${vatAmount.toFixed(2)}` : typeof vatAmount === "string" ? vatAmount : "0.00";

            const formattedSubtotal = typeof subtotal === "number" ? `${subtotal.toFixed(2)}` : typeof subtotal === "string" ? subtotal : "0.00";

            const formattedTax =
              typeof initialPayment === "number" ? `${initialPayment.toFixed(2)}` : typeof initialPayment === "string" ? initialPayment : "0.00";

            const formattedClearedOldBalance =
              typeof clearedOldBalance === "number" ? `${clearedOldBalance.toFixed(2)}` : typeof clearedOldBalance === "string" ? clearedOldBalance : "0.00";

            const deliveryFee = invoiceData.transactionDetails?.deliveryFee || 0;
            const serviceCharge = invoiceData.transactionDetails?.serviceCharge || 0;
            const extraPayment = invoiceData.transactionDetails?.extraPayment || 0;

            const totalExtraCharges = Number(deliveryFee) + Number(serviceCharge) + Number(extraPayment);

            const formattedTotalDue = totalDue.toLocaleString();
            /* const formattedTotalDue = typeof totalDue === "number" ? `${totalDue.toFixed(2)}` : typeof totalDue === "string" ? totalDue : "0.00"; */

            // Subtotal - align with ITEM column (left) and AMOUNT column (right)
            doc.setFont("times", "normal");
            doc.text("Subtotal", col1X + 5, subtotalY); // Match the ITEM column left padding
            doc.text(`${formattedSubtotal}`, tableEndX - 5, subtotalY, { align: "right" }); // Match the AMOUNT column right padding

            // Discount - align with ITEM column (left) and AMOUNT column (right)
            doc.setFontSize(9);
            doc.setFont("times", "normal");

            //Vat section
            if (invoiceData.transactionDetails.vat > 0) {
              doc.text("VAT", col1X + 5, taxY); // Match the ITEM column left padding

              doc.text(`${formattedVat}`, tableEndX - 5, taxY, { align: "right" }); // Match the AMOUNT column right padding
            } else {
              doc.text("VAT", col1X + 5, taxY); // Match the ITEM column left padding

              doc.text("Excluded", tableEndX - 5, taxY, { align: "right" }); // Match the AMOUNT column right padding
            }

            doc.text("Old balance cleared", col1X + 5, taxY + 5); // Match the ITEM column left padding
            doc.text(` +${formattedClearedOldBalance.toLocaleString()}`, tableEndX - 5, taxY + 5, { align: "right" }); // Match the AMOUNT column right padding

            if (totalExtraCharges > 0) {
              doc.text("Total Extra charges (More info in the app) ", col1X + 5, taxY + 10); // Match the ITEM column left padding
              doc.text(` +${totalExtraCharges.toLocaleString()}`, tableEndX - 5, taxY + 10, { align: "right" }); // Match the AMOUNT column right padding

              taxY += 5; // Move down for discount if extra charges exist to avoid overlap
              lineY += 5;
              totalDueY += 5;
            }

            // Gray color for discount

            doc.text("Discount", col1X + 5, taxY + 10); // Match the ITEM column left padding
            doc.text(` -${discount.toLocaleString()}`, tableEndX - 5, taxY + 10, { align: "right" }); // Match the AMOUNT column right padding

            // Tax - align with ITEM column (left) and AMOUNT column (right)
            doc.setFontSize(9);
            doc.setDrawColor(220, 220, 220);

            if (invoiceData.operationType.whichOperation === "loan") {
              doc.text("Initial Payment", col1X + 5, taxY + 15); // Match the ITEM column left padding

              doc.text(` ${formattedTax}`, tableEndX - 5, taxY + 15, { align: "right" }); // Match the AMOUNT column right padding
            } else {
              doc.text("Paid Amount", col1X + 5, taxY + 15); // Match the ITEM column left padding

              doc.text(` ${formattedTotalDue}`, tableEndX - 5, taxY + 15, { align: "right" }); // Match the AMOUNT column right padding
            }

            /* doc.text("Initial Payment", col1X + 5, taxY); // Match the ITEM column left padding

            doc.text(` ${formattedTax}`, tableEndX - 5, taxY, { align: "right" }); // Match the AMOUNT column right padding */

            /* aading cleared amount */
            doc.setFontSize(10);
            doc.setFont("times", "normal");

            doc.setTextColor(34, 171, 43); // Green color for cleared amount
            invoiceData.operationType.whichOperation === "loan" && doc.text("Total paid", col1X + 5, taxY + 20); // Match the ITEM column left padding
            invoiceData.operationType.whichOperation === "loan" &&
              doc.text(`${invoiceData.operationType.clearedAmount || 0}`, tableEndX - 5, taxY + 20, { align: "right" });

            /* adding balance */
            doc.setFontSize(10);
            doc.setFont("times", "bold");
            doc.setTextColor(244, 67, 54); // Red color for balance
            invoiceData.operationType.whichOperation === "loan" && doc.text("Balance", col1X + 5, taxY + 25); // Match the ITEM column left padding
            invoiceData.operationType.whichOperation === "loan" &&
              doc.text(`${invoiceData.operationType.balance}`, tableEndX - 5, taxY + 25, { align: "right" }); // Match the AMOUNT column right padding

            // Horizontal line
            doc.setDrawColor(220, 220, 220);
            doc.setLineWidth(0.5);
            if (invoiceData.operationType.whichOperation === "loan") {
              doc.line(tableX, lineY + 18, tableEndX, lineY + 18);
            } else {
              doc.line(tableX, lineY + 10, tableEndX, lineY + 10);
            }

            // Total Due - align with ITEM column (left) and AMOUNT column (right)
            doc.setFontSize(11);
            doc.setFont("times", "bold");
            doc.setTextColor(0, 0, 0); // Reset text color
            if (invoiceData.operationType.whichOperation === "loan") {
              doc.text("Total Price", col1X + 5, totalDueY + 15);
              doc.text(`${currency} ${formattedTotalDue}`, tableEndX - 5, totalDueY + 15, { align: "right" });
            } else {
              doc.text("Total Price", col1X + 5, totalDueY + 8);
              doc.text(`${currency} ${formattedTotalDue}`, tableEndX - 5, totalDueY + 10, { align: "right" });
            }
          }
        }
      }

      // Add footer to the last page

      addPageFooter(currentPage, totalPages); // Use pre-calculated total pages

      // Output as blob
      try {
        const pdfBlob = doc.output("blob");
        const dataUri = doc.output("datauristring"); // Get data URL for debugging
        const base64PDF = dataUri.split(",")[1];
        // if only sending as email return here dont preview

        if (sendAsEmail) {
          setPdfBlob(pdfBlob); // Set the blob to state in parent component to forward to backend
          console.log("PDF Blob set for email:");

          return;
        }

        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Detect mobile (simple UA check or matchMedia is fine)
        const isMobile = /Mobi|Android/i.test(navigator.userAgent);

        if (isMobile) {
          // Open in new tab for mobile devices
          // window.open(pdfUrl, "_blank");
          openPdfPreview(pdfBlob, base64PDF);
          // downloadBlob(pdfBlob, `invoice_${invoiceData.transID}.pdf`);
        } else {
          //Desktop or non-mobile devices
          // Open in new tab with iframe for better viewing
          const newWindow = window.open();
          if (newWindow) {
            newWindow.document.write(`
              <html>
                <head>
                  <title>Invoice #${invoiceData.transID}</title>
                  <style>
                    body, html {
                      margin: 0;
                      padding: 0;
                      height: 100%;
                      overflow: hidden;
                    }
                    iframe {
                      width: 100%;
                      height: 100%;
                      border: none;
                    }
                  </style>
                </head>
                <body>
                  <iframe src="${pdfUrl}" type="application/pdf" width="100%" height="100%"></iframe>
                </body>
              </html>
            `);
            newWindow.document.close(); // Close the document to render the iframe
          } else {
            // Fallback if popup blocked
            window.open(pdfUrl, "_blank");
          }
          /* sendAsEmail &&
            setTimeout(() => {
              // Close the new window after 5 seconds
              newWindow.close();
            }, 3000); */
        }
      } catch (outputError) {
        console.log("Error creating or opening PDF:", outputError);
        throw new Error(`Error creating or opening PDF: ${outputError.message}`);
      }
    } catch (error) {
      setErrorMessage(`${error.message || "Unknown error generating PDF"}`);
      console.error("Error generating PDF:", error);
    } finally {
      // Reset loading state
      setIsGenerating(false);
    }
  };

  return (
    <>
      <div className='pdf-generator-container'>
        {errorMessage && (
          <div
            style={{
              color: "red",
              marginTop: "10px",
              fontSize: "14px",
              backgroundColor: "#fff0f0",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ffd0d0",
              maxWidth: "400px",
            }}
          >
            <strong>Error:</strong> {errorMessage}
            <br />
            <small>Please check browser console for more details (Press F12)</small>
          </div>
        )}
      </div>
    </>
  );
};

export default InvoicePDF;

export async function openPdfPreview(blob, base64PDF) {
  const url = URL.createObjectURL(blob);
  const w = window.open("", "_blank"); // popup/tab

  if (!w) {
    // popup blocked – fallback to same-tab below
    openPdfInSameTab(blob, base64PDF);
    // download the PDF instead
    // downloadBlob(blob, `invoice_${Date.now()}.pdf`);
    return;
  }

  // if its a react Native webview

  if (window.ReactNativeWebView) {
    try {
      // 5️⃣ Post it to React Native
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: "VIEW_PDF", url: base64PDF }));

      return;
    } catch (error) {
      uiAlert(`Error opening PDF try again `, "error");
    }
  }

  w.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta name="viewport" content="width=device-width,initial-scale=1">
        <title>PDF preview</title>
        <style>
          html,body { margin:0;height:100%; }
          embed,iframe { width:100%;height:100%;border:none; }
        </style>
      </head>
      <body>
        <embed src="${url}" type="application/pdf">
      </body>
    </html>
  `);
  w.document.close();

  // optional: revoke when the tab unloads
  w.addEventListener("unload", () => URL.revokeObjectURL(url));
}

async function openPdfInSameTab(blob, base64PDF) {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ type: "VIEW_PDF", url: base64PDF }));
    return;
  }
  const dataURL = await new Promise((res) => {
    const reader = new FileReader();
    reader.onload = () => res(reader.result);
    reader.readAsDataURL(blob); // produces data:application/pdf;base64,…
  });

  window.location.href = dataURL; // navigates current tab to the PDF
}

function downloadBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);

  // create a temporary <a download="…"> element
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName; // forces “Save” instead of view
  a.style.display = "none";

  document.body.appendChild(a);
  a.click(); // programmatically click
  document.body.removeChild(a);

  // tidy up the object-URL after the browser has had time to start the download
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
